/** A null typedQuery means the user is not editing the field. */

/**
 * Withholding the prop mid-edit is load-bearing: a defined searchQuery makes the Northstar
 * Dropdown's own synchronous setter a no-op, and that setter is what holds the caret. Collapsing
 * this to `typedQuery ?? committedLabel` sends the caret to the end on every keystroke.
 */
export const searchQueryProp = (typedQuery: string, committedLabel: string) =>
  typedQuery === null ? committedLabel : undefined;

export const activeQuery = (typedQuery: string, committedLabel: string) =>
  typedQuery ?? committedLabel;
